export default {
  actions: '操作',
  view: '查看',
  edit: '编辑',
  delete: '删除',
};
